.errorState {
  display: flex;
  align-items: flex-start;
  gap: var(--space-4);
  max-width: var(--measure-prose);
  padding: var(--space-5);
  border: 1px solid var(--line-subtle);
  border-left: 3px solid var(--negative);
  border-radius: var(--radius-lg);
  background: var(--negative-wash);
}

.mark {
  display: grid;
  place-items: center;
  width: var(--space-6);
  height: var(--space-6);
  border: 1px solid var(--negative);
  border-radius: var(--radius-pill);
  color: var(--negative);
  font-family: var(--font-display);
  font-weight: 700;
  flex-shrink: 0;
}

.content {
  display: grid;
  gap: var(--space-2);
  min-width: 0;
}

.title {
  color: var(--ink-primary);
  font-family: var(--font-display);
  font-size: var(--text-lg);
  letter-spacing: var(--tracking-wide);
}

.body {
  color: var(--ink-secondary);
  font-size: var(--text-sm);
  line-height: var(--leading-relaxed);
}

.action {
  margin-top: var(--space-2);
}
